import React, { FC, useRef, useState } from 'react';
import DescLabel from 'src/components/atoms/label/DescLabel';
import { addComma } from 'src/utils/common';
import { myInfoDataStore } from 'src/store/myInfo';
import { salaryDataStore } from 'src/store/mySalaryInfo';
import { preworkDataStore } from 'src/store/preworkInfo';
import { settlementDataStore } from 'src/store/settlementInfo';

import './style.scss';

interface Props {}

const TotalIncome: FC<Props> = () => {
  const dataSet = {};

  // const myInfoDataStateResult = myInfoDataStore((state: any) => state.result).data || {};
  const salaryInfoDataStateResult = salaryDataStore((state: any) => state.result);
  const preworkInfoDataStateResult = preworkDataStore((state: any) => state.result).data || [];
  const settlementData = settlementDataStore((state: any) => state.result).data?.result || {};

  const totalSalary = settlementData?.gross_salary || 0;

  // 현재급여 + 이전 급여(상여도 포함인지 확인)
  // const nowSalary = salaryInfoDataStateResult.data?.tsal_base || 0;
  // let totalSalary = nowSalary;
  // preworkInfoDataStateResult.forEach((item: any) => {
  //   const preSalary = item.tsal_base || 0;
  //   totalSalary += preSalary;
  // });

  // addComma(resultSet.gross_salary)

  return (
    <div className="_step_b_total_income">
      <div className="_content">
        <div className="_count">
          {addComma(totalSalary)}
          <em className="_ft_px_t1">만원</em>
        </div>
        <div className="_desc">
          <DescLabel content="종전 근무지 소득 + 현근무지 소득" styleDef={{ color: '#555' }} />
        </div>
      </div>
    </div>
  );
};

export default TotalIncome;
